import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { AGENCY_LIST_QUERY_KEY } from "../constants/querykeys";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "@entities/influencer/lib/constants";

export function useDeLinkInfluencer() {
  const {
    mutate: deLinkInfluencer,
    isLoading: isDeLinking,
    isSuccess: isDeLinked,
    variables,
  } = useMutation<
    {
      agencyId: string;
      influencerId: string;
    },
    BackednResponse<any> | void
  >({
    mutationFn: async ({ agencyId, influencerId }) => {
      try {
        const res = await AgencyService.deLinkInfluencer(
          agencyId,
          influencerId
        );
        return res as BackednResponse<any>;
      } catch (err: any) {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }
    },
    options: {
      queryKey: AGENCY_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { agencyId }) => {
      c.invalidateQueries({ queryKey: INFLUENCER_LIST_QUERY_KEY });
    },
  });

  return {
    deLinkInfluencer,
    isDeLinking,
    isDeLinked,
    variables,
  };
}
